export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4072123f9fa45d836d6729120e101410e31eabf7a1&name=revalidateCommunity!'